import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {CurrentTransactionService} from "../../services/communication/currentTransactionService";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {FamilyAlbum} from "../../model/family-album";
import {BusinessService} from "../../services/data/business.service";
import {CurrentEventService} from "../../services/communication/currentEventService";
import {BusinessRight} from "../../model/business-right";
import {AuthentService} from "../../services/authent.service";

@Component({
  selector: 'pricing-page',
  template: require('./pricing-page.component.html'),
  styles: [
    require('./pricing-page.component.scss')
  ]
})

export class PricingPageComponent {

  // album creation
  model: FamilyAlbum = new FamilyAlbum();
  submitted = false;
  eventType:string;

  date:number;
  isPublic:boolean = false;
  isDateValid:boolean = false;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    selectionTxtFontSize: '16px'
  };

  business: Business;

  active: string;

  priceType: string;

  constructor(private router: Router, private currentTransactionService: CurrentTransactionService,
              private currentBusinessService: CurrentBusinessService,
              private businessService: BusinessService, private currentEventService: CurrentEventService,
              private authent: AuthentService) {
    this.active = 'demand';
    this.priceType = 'ht';

    if (currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;
    }

    currentBusinessService.businessChange$.subscribe(business => this.business = this.currentBusinessService.currentBusiness);
  }


  premiumSelection(type: string) {
    this.currentTransactionService.createNewTransaction();
    this.router.navigateByUrl('order/account/' + type);
  }

  canCreate():boolean {
    let right:BusinessRight = this.authent.getRight();

    if (right != null) {
      return this.authent.getRight().canCreate;
    }

    return false;
  }

  onDateChanged(event:any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc*1000;
    } else {
      this.isDateValid = false;
    }
  }

  createEvent() {
    this.model.date = this.date;

    this.businessService.createEvent(this.currentBusinessService.currentBusiness.id, this.model)
      .subscribe(
        event => {
          this.currentEventService.changeEvent(event);
          this.router.navigateByUrl('order/event/'+this.eventType);
        },
        error => {
          console.log(error)
        }
      );
  }

  creationClose() {
    this.model = new FamilyAlbum();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/pricing/pricing-page.component.ts